export const environment = {
  production: false,
  ENV: 'prodtest',
  BASEDOMAIN: 'prodtest-api.edulinksolutions.com',
  PORT: '',
  BASEURI: 'https://prodtest-api.edulinksolutions.com',
  ASSETSURI: 'https://prodtest-paetep.edulinksolutions.com',
  FIREBASECONFIG: {
    apiKey: "AIzaSyC6Oyps1jsm38LpaAEMHiq4KapSZJZZ5ls",
    authDomain: "edl-identity.firebaseapp.com"
  },
  FIREBASE_TENANT: ""
};
